module.exports = __webpack_public_path__ + "static/media/proj11_img1.b7dd3f68.jpg";